const AgreementCard = ({
  agreement,
  onPreview,
  agreed,
  setAgreed,
  isLocked,
}) => {
  const disabled = agreed || isLocked;

  return (
    <div className="flex flex-col">
      <label className="mb-1 mt-4 text-sm text-labelColour whitespace-normal break-words">
        {agreement.name}
      </label>

    { agreement.preview&& <div
        onClick={() => onPreview(agreement.preview)}
        className={`mt-4 cursor-pointer bg-white shadow-md rounded-lg flex items-center justify-between px-3 py-2 border
        `}
      >
        <span className="underline text-black">
          {agreement.preview?.name}
        </span>
        {disabled ? <span className="text-green-500 text-xs">
          Already accepted
        </span>
        :<span className="text-gray-500 text-xs">
          Click to view
        </span>
}
      </div>}

      <div className="flex items-center mt-2 space-x-2">
        <input
          type="checkbox"
          checked={agreed}
          disabled={disabled}
          onChange={(e) => setAgreed(e.target.checked)}
          className="h-4 w-4"
        />
        <label className={`${agreed?"text-black" : "text-gray-400"} whitespace-normal break-words`}>
         {agreement.preview?"I have read and agree":agreement.description}
        </label>
      </div>
    </div>
  );
};

export default AgreementCard;